export default {
  add: {
    method: 'post',
    url: '/price/vendor'
  },
  gets: {
    method: 'post',
    url: '/price/vendor/list'
  },
  delete: {
    method: 'delete',
    url: '/price/vendor'
  },
  archive: {
    method: 'delete',
    url: '/price/vendor/archive'
  },
  restore: {
    method: 'put',
    url: '/price/vendor/restore'
  },
  update: {
    method: 'put',
    url: '/price/vendor/ID'
  },
  get: {
    method: 'get',
    url: '/price/vendor/ID'
  }
}
